import DefaultAgent from "./DefaultAgent";
import RafiVPos from "./RafiVPos";
import VivaSmart from "./VivaSmart";

export default function Agents({ agent, selected }) {

    switch (agent?.useOnline?.profileType) {
        case "vivaSmartCheckout": return <VivaSmart agent={agent} selected={selected} />
        case "rafiVPOS": return <RafiVPos agent={agent} selected={selected} />
        default: return <DefaultAgent agent={agent} selected={selected} />
    }
}